// In your Main.tsx (or any existing page)
import { collection, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config/firebase';

export const ScriptTest = () => {
    // ... your existing code ...

    // Add this initialization function directly in the component
    const handleInitializeData = async () => {
        if (!window.confirm("This will initialize the database. Run only once!")) {
            return;
        }

        try {
            // 1. Create schools
            const schools = [
                { name: "Plano East Senior High" },
                { name: "Plano West Senior High" },
                { name: "John Paul II High School" },
                { name: "Independence High School" }
            ];

            const schoolIds: { [key: string]: string } = {};

            for (const school of schools) {
                const schoolRef = doc(collection(db, "schools"));
                await setDoc(schoolRef, {
                    ...school,
                    createdBy: "system",
                    createdAt: serverTimestamp()
                });
                schoolIds[school.name] = schoolRef.id;
                console.log(`Created school: ${school.name}`);
            }

            // 2. Create courses  
            const courses = [
                { name: "AP Computer Science Principles", schoolName: "Plano East Senior High" },
                { name: "AP Human Geography", schoolName: "Plano East Senior High" }
                // Add more as needed
            ];

            for (const course of courses) {
                const courseRef = doc(collection(db, "courses"));
                await setDoc(courseRef, {
                    name: course.name,
                    schoolId: schoolIds[course.schoolName],
                    createdBy: "system",
                    createdAt: serverTimestamp()
                });
                console.log(`Created course: ${course.name}`);
            }

            alert("Database initialized successfully!");
        } catch (error) {
            console.error("Error:", error);
            alert("Error initializing database");
        }
    };

    return (
        <div>
            {/* Your existing JSX */}
            
            {/* Add this temporary button anywhere in your JSX */}
            <button 
                onClick={handleInitializeData}
                style={{
                    background: 'red',
                    color: 'white', 
                    padding: '10px',
                    margin: '10px',
                    border: 'none',
                    borderRadius: '5px'
                }}
            >
                🚨 Initialize DB (Run Once Only)
            </button>
            
            {/* Rest of your existing JSX */}
        </div>
    );
};